import React, { Component } from "react"
import SbEditable from "storyblok-react"
import linkHandler from "../../helpers/storyblokLinkHandler"
import Components from "../index"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import {
  StyledProgramDetail,
  StyledProgramHeader,
  StyledProgramContent,
  StyledProgramTitle,
  StyledProgramDesc,
  StyledProgramAttrList,
  StyledProgramButton,
} from "./partials"

class ProgramDetail extends Component {
  render() {
    const { blok } = this.props
    return (
      <SbEditable content={blok}>
        <StyledProgramDetail>
          {blok.heading && (
            <StyledProgramHeader
              programCategory={blok.program_category}
              programHeaderImage={
                blok.header_image ? blok.header_image.filename : ""
              }
            >
              <p>{blok.heading}</p>
            </StyledProgramHeader>
          )}
          <StyledProgramContent>
            <div>
              {blok.title && (
                <StyledProgramTitle
                  title={blok.title}
                  href={linkHandler(blok.button[0].link)}
                >
                  <p>{blok.title}</p>
                </StyledProgramTitle>
              )}
              {blok.description && (
                <StyledProgramDesc>
                  {
                    unified()
                      .use(remarkParse)
                      .use(remarkRehype)
                      .use(rehypeReact, {
                        createElement: React.createElement,
                        components: remarkReactComponents,
                        Fragment: React.Fragment,
                      })
                      .processSync(blok.description).result
                  }
                </StyledProgramDesc>
              )}
            </div>
            <div>
              {blok.program_attribute && (
                <StyledProgramAttrList>
                  {blok.program_attribute &&
                    blok.program_attribute.map((content) =>
                      React.createElement(Components(content.component), {
                        key: content._uid,
                        blok: content,
                        programCategory: blok.program_category,
                      })
                    )}
                </StyledProgramAttrList>
              )}
              {blok.button && (
                <StyledProgramButton>
                  {blok.button &&
                    blok.button.map((content) =>
                      React.createElement(Components(content.component), {
                        key: content._uid,
                        blok: content,
                      })
                    )}
                </StyledProgramButton>
              )}
            </div>
          </StyledProgramContent>
        </StyledProgramDetail>
      </SbEditable>
    )
  }
}

export default ProgramDetail
